/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shared_QuarterInputs */

const en_shared_quarter = /** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`quarter`)
};

const de_shared_quarter = /** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quartal`)
};

const es_shared_quarter = /** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trimestre`)
};

const fr_shared_quarter = /** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`trimestre`)
};

/** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */
const it_shared_quarter = en_shared_quarter;

/** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */
const pt_br2_shared_quarter = en_shared_quarter;

/** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */
const pl_shared_quarter = en_shared_quarter;

/** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */
const hu_shared_quarter = en_shared_quarter;

/** @type {(inputs: Shared_QuarterInputs) => LocalizedString} */
const ro_shared_quarter = en_shared_quarter;

/**
* | output |
* | --- |
* | "quarter" |
*
* @param {Shared_QuarterInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const shared_quarter = /** @type {((inputs?: Shared_QuarterInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shared_QuarterInputs, { locale?: "en" | "de" | "es" | "fr" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shared_quarter(inputs)
	if (locale === "de") return de_shared_quarter(inputs)
	if (locale === "es") return es_shared_quarter(inputs)
	if (locale === "fr") return fr_shared_quarter(inputs)
	if (locale === "it") return it_shared_quarter(inputs)
	if (locale === "pt-BR") return pt_br2_shared_quarter(inputs)
	if (locale === "pl") return pl_shared_quarter(inputs)
	if (locale === "hu") return hu_shared_quarter(inputs)
	return ro_shared_quarter(inputs)
});
export { shared_quarter as "shared.quarter" }